import { AlbumOverlayConfig, OverlayAnchor } from '../types';

export const ALL_ANCHORS: OverlayAnchor[] = [
  'top-left',
  'top-center',
  'top-right',
  'middle-left',
  'middle-center',
  'middle-right',
  'bottom-left',
  'bottom-center',
  'bottom-right',
];

/**
 * Returns the set of anchor positions that are unavailable for the overlay
 * config at `selfIndex`. Includes:
 *   - every anchor used by another manual overlay config (excluding selfIndex)
 *   - the `defaultAnchor` if `defaultBranded` is true (system watermark slot)
 *
 * Pass `selfIndex = -1` when computing reservations for an overlay that
 * isn't yet in the list (e.g. when picking an anchor for a freshly added one).
 */
export function getReservedAnchors(
  configs: AlbumOverlayConfig[],
  selfIndex: number,
  opts?: { defaultBranded?: boolean; defaultAnchor?: OverlayAnchor },
): Set<OverlayAnchor> {
  const reserved = new Set<OverlayAnchor>();
  configs.forEach((c, i) => {
    if (i === selfIndex) return;
    reserved.add(c.anchor);
  });
  if (opts?.defaultBranded && opts.defaultAnchor) {
    reserved.add(opts.defaultAnchor);
  }
  return reserved;
}

/**
 * Picks the first anchor from a preferred order that isn't already reserved.
 * Used when adding a new overlay so we don't drop two overlays on the same
 * spot by default. Falls back to `bottom-right` if every anchor is taken.
 */
export function pickFreeAnchor(
  reserved: Set<OverlayAnchor>,
  preferred: OverlayAnchor[] = ['bottom-right', 'bottom-center', 'bottom-left', 'top-right', 'top-center', 'top-left', 'middle-right', 'middle-center', 'middle-left'],
): OverlayAnchor {
  for (const a of preferred) {
    if (!reserved.has(a)) return a;
  }
  return 'bottom-right';
}
